
import {
    Route,
    Switch,
    Redirect
} from "react-router-dom";
import { routes } from "./routes";
import Chart from 'chart.js/auto'

export const MotoclickRouter = () => {
    return (
        <div>
            <Switch>
                {
                    routes.map(({ to, Component })=>(
                        <Route 
                            key={to}
                            path={to} 
                            component={Component}
                        />
                    ))
                }
                <Redirect to="/map-screem"/>
            </Switch>
        </div>
    )
}